import { ValueOfKey } from '../../utils-types';

export const DATE_RANGE_PRESETS = {
  '7D': '7D',
  '4W': '4W',
  '3M': '3M',
  '1Y': '1Y',
  YTD: 'YTD',
} as const;

export type DateRangePreset = ValueOfKey<typeof DATE_RANGE_PRESETS>;

export const dateRangePresetsToTitlesMap: Record<DateRangePreset, string> = {
  '7D': 'week',
  '4W': '4 weeks',
  '3M': '3 months',
  '1Y': 'year',
  YTD: 'period',
};

export const dateRangePresetsToComparisonPeriodMap: Record<DateRangePreset, string> = {
  '7D': 'last 7 days',
  '4W': 'last 4 weeks',
  '3M': 'last 3 months',
  '1Y': 'last year',
  YTD: 'previous period',
};
